import { render, staticRenderFns } from "./workflowTour.vue?vue&type=template&id=4c46359a&scoped=true&"
import script from "./workflowTour.vue?vue&type=script&lang=js&"
export * from "./workflowTour.vue?vue&type=script&lang=js&"
import style0 from "./workflowTour.vue?vue&type=style&index=0&id=4c46359a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46359a",
  null
  
)

export default component.exports